import {
  Google,
  CalendarToday,
  Schedule,
  ContactMail,
  Groups,
} from "@mui/icons-material";

export const TEAM_SCHEDULING_PROVIDER = "team-scheduling";
export const DEFAULT_PROVIDER = "google-calendar";

export const calendarProviders = [
  {
    id: "google-calendar",
    name: "Google Calendar",
    logo: "https://upload.wikimedia.org/wikipedia/commons/a/a5/Google_Calendar_icon_%282020%29.svg",
    description: "Connect your Google Calendar and configure custom working hours",
    color: "#219297",
    icon: <Google />,
    hasVideo: true,
    type: "single-user",
  },
  {
    id: "calendly",
    name: "Calendly",
    logo: "https://www.bing.com/th/id/OIP.isWc_EiA6Ms4U-FNJlRwEwHaHa?w=193&h=211&c=8&rs=1&qlt=90&o=6&cb=ucfimg1&pid=3.1&rm=2&ucfimg=1",
    description: "Professional scheduling and meeting management",
    color: "#00A4FF",
    icon: <Schedule />,
    hasVideo: true,
    type: "single-user",
  },
  {
    id: "zoho-calendar",
    name: "Zoho Calendar",
    logo: "https://www.zoho.com/branding/images/zoho-logo.png",
    description: "Appointment scheduling with Zoho integration",
    color: "#E42526",
    icon: <CalendarToday />,
    hasVideo: true,
    type: "single-user",
  },
  {
    id: "contact-form",
    name: "Contact Form",
    logo: "",
    description: "Your contact page or form URL for inquiries",
    color: "#6B46C1",
    icon: <ContactMail />,
    hasVideo: false,
    type: "single-user",
  },
  {
    id: TEAM_SCHEDULING_PROVIDER,
    name: "Team Scheduling",
    logo: "",
    description: "Round-robin scheduling with multiple team members",
    color: "#FF6900",
    icon: <Groups />,
    hasVideo: true,
    type: "team",
  },
];

export const providerInstructions = {
  "google-calendar": [
    { title: "Connect Google Calendar", content: "Click 'Connect Google Calendar' to authorize access." },
    { title: "Configure Working Hours", content: "Set your daily working hours and days of availability." },
    { title: "Set Booking Preferences", content: "Configure slot duration, buffer times, and booking window." },
    { title: "Enable Booking", content: "Activate your calendar to start accepting bookings." },
  ],
  "calendly": [
    { title: "Sign in to Calendly", content: "Access your Calendly dashboard." },
    { title: "Create Event Type", content: "Create a new event type (15 min, 30 min, custom, etc.)." },
    { title: "Configure Settings", content: "Set availability, location, and form questions." },
    { title: "Publish & Share", content: "Publish the event type and copy the 'Share your link' URL." },
    { title: "Paste URL", content: "Use the copied Calendly link as your booking URL." },
  ],
  "zoho-calendar": [
    { title: "Sign in to Zoho Calendar", content: "Access your Zoho Calendar dashboard." },
    { title: "Navigate to Settings", content: "Right-click the calendar from the left pane and click Edit, or go to Settings > Calendar > My Calendars" },
    { title: "Enable public access", content: "Under Sharing and permissions > Public access, enable public access for the calendar." },
    { title: "Configure permissions", content: "Choose if you want others to View only free/busy status or View event details." },
    { title: "Customize interface", content: "Click Customize near Schedule Appointment to customize your interface." },
    { title: "Choose language and color", content: "Choose desired language and color for your interface." },
    { title: "Copy the iframe source URL", content: "Copy the src URL from the iframe under Schedule Appointment section." },
    { title: "Paste the URL here", content: "Paste the copied URL in the field above." },
  ],
  "contact-form": [
    { title: "Ensure Accessibility", content: "Make sure the page is publicly accessible and not behind a login." },
    { title: "Form Functionality", content: "Ensure the form is working properly and can receive messages." },
    { title: "Paste URL", content: "Paste your contact page URL in the field on the left." },
  ],
  "team-scheduling": [
    { title: "Connect Google Calendar", content: "Enable Google Calendar integration first to access team scheduling." },
    { title: "Configure Team Members", content: "Add team members who have shared their calendars with you." },
    { title: "Set Scheduling Rules", content: "Configure working hours, slot duration, and booking rules." },
    { title: "Handle Night Shifts", content: "For night shifts (6 PM - 3 AM), set end time to next day hour." },
  ],
};

export const providerExamples = {
  "google-calendar": "No URL needed - Connect and configure working hours directly",
  "calendly": "https://calendly.com/yourname/event\nhttps://calendly.com/yourname/30min",
  "zoho-calendar": "https://calendar.zoho.com/book/yourname\nhttps://calendar.zoho.com/meeting/abc123",
  "contact-form": "https://yourwebsite.com/contact\nhttps://yourwebsite.com/contact-form",
  "team-scheduling": "https://yourdomain.com/api/public/booking/availability\n(Generated automatically)",
};

export const providerPricing = {
  "google-calendar": "Free",
  "calendly": "Free",
  "zoho-calendar": "Included in Zoho Workplace paid plans",
  "contact-form": "Free (Your own website)",
  "team-scheduling": "Free",
};

export const providerPlaceholders = {
  "google-calendar": "No URL needed - Connect and configure working hours",
  "calendly": "Enter your Calendly event URL",
  "zoho-calendar": "Enter your Zoho Calendar booking URL",
  "contact-form": "Enter your contact page/form URL",
  "team-scheduling": "Team scheduling uses connected Google Calendar",
};

export const providerLabels = {
  "google-calendar": "Google Calendar Configuration",
  "calendly": "Calendly Event URL",
  "zoho-calendar": "Zoho Calendar Booking URL",
  "contact-form": "Contact Page/Form URL",
  "team-scheduling": "Team Scheduling Configuration",
};